module.exports = __webpack_public_path__ + "img/password.69c6be2f.svg";